import { Bell, CheckCircle } from "react-bootstrap-icons";
import styles from "./DeviceSections.module.css";

const formatAlertType = (type) => {
  if (!type) return "Unknown Alert";

  return type
    .split("_")
    .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
    .join(" ");
};

const getAlertDate = (alert) => {
  const dateSource = alert?.datetime || (alert?.timestamp ? alert.timestamp * 1000 : null);
  if (!dateSource) return null;

  const date = new Date(dateSource);
  if (Number.isNaN(date.getTime())) return null;

  return date;
};

const AlertsSection = ({ alerts }) => {
  if (!alerts?.length) {
    return (
      <div className={styles.alertsEmpty}>
        <div className={styles.alertsEmptyIconWrap}>
          <CheckCircle size={30} className={styles.alertsEmptyIcon} />
        </div>
        <p className={styles.alertsEmptyTitle}>No Active Alerts</p>
        <p className={styles.alertsEmptySubtext}>This device has no alerts at the moment.</p>
      </div>
    );
  }

  const sortedAlerts = [...alerts].sort((a, b) => {
    const aTime = getAlertDate(a)?.getTime() || 0;
    const bTime = getAlertDate(b)?.getTime() || 0;
    return bTime - aTime;
  });

  return (
    <div className={styles.sectionStack}>
      {sortedAlerts.map((alert, i) => {
        const alertDate = getAlertDate(alert);
        const alertType = formatAlertType(alert?.type);

        return (
        <div key={i} className={styles.alertItem}>
          <Bell size={17} className={styles.alertIcon} />
          <div className={styles.alertContent}>
            <div className={styles.alertTopRow}>
              <p className={styles.alertTitle}>{alertType} detected</p>
            </div>
            <p className={styles.alertMeta}>
              {alertDate
                ? `${alertDate.toLocaleDateString()} at ${alertDate.toLocaleTimeString()}`
                : "Time unavailable"}
            </p>
          </div>
        </div>
        );
      })}
    </div>
  );
};

export default AlertsSection;
